import { clampTo } from '../../tools';
import type { KieModelConfig } from '../types';
import { UPSCALE_PROMPT, REFRAME_PROMPT, REPAINT_PROMPT_PREFIX } from '../../wrapped-prompts';

export const wrappedConfigs: Record<string, KieModelConfig> = {
    'gpt-image-2-upscale': {
        enableTranslation: false,
        buildInput: (params) => {
            const { image_urls, image_resolution } = params;
            return {
                model: 'gpt-image-2-image-to-image',
                input: {
                    prompt: UPSCALE_PROMPT,
                    aspect_ratio: 'auto',
                    resolution: clampTo(image_resolution?.toUpperCase() || '1K', ['1K', '2K', '4K'] as const, '1K'),
                    // 图片 URL
                    input_urls: image_urls!.slice(0, 1),
                },
            };
        },
    },
    'gpt-image-2-reframe': {
        enableTranslation: false,
        buildInput: (params) => {
            const { image_urls, aspectRatio, image_resolution } = params;
            return {
                model: 'gpt-image-2-image-to-image',
                input: {
                    prompt: REFRAME_PROMPT,
                    aspect_ratio: clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:1', '1:3', '3:2', '2:3', '2:1', '1:2', '1:1'] as const, '16:9'),
                    resolution: clampTo(image_resolution?.toUpperCase() || '1K', ['1K', '2K', '4K'] as const, '1K'),
                    // 图片 URL
                    input_urls: image_urls!.slice(0, 1),
                },
            };
        },
    },
    'gpt-image-2-repaint': {
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, image_resolution } = params;
            return {
                model: 'gpt-image-2-image-to-image',
                input: {
                    prompt: `${REPAINT_PROMPT_PREFIX}${prompt || ''}`.slice(0, 20000),
                    aspect_ratio: 'auto',
                    resolution: clampTo(image_resolution?.toUpperCase() || '1K', ['1K', '2K', '4K'] as const, '1K'),
                    // 图片 URL
                    input_urls: image_urls!.slice(0, 2),
                },
            };
        },
    },
};